import React, { useEffect, useState } from "react";
import moment from "moment-timezone";
import { TableCell, Typography, Link, TableRow, Tooltip, Chip, IconButton } from '@mui/material';
import { useNavigate } from "react-router-dom";
import { useUserDetailsQuery } from 'services/user'

const classes = {
    evenRow: {
        height: "40px",
        cursor: "pointer",
        '&:hover': {
            backgroundColor: "#d9e6f7"
        },
    },
    oddRow: {
        height: "40px",
        backgroundColor: '#f0f4f9',
        cursor: "pointer",
        '&:hover': {
            backgroundColor: "#d9e6f7"
        },
    },
    body2: {
        fontSize: "12px",
        fontWeight: '600',
        fontFamily: 'Montserrat',
        //padding: '10px'
    },
    fabButton: {
        backgroundColor: "transperent",
        color: "#DE350B"
    },
    cell: {
        padding: "10px"
    }
};

const PrivateDBRow = (props) => {
    const { record, index } = props.value;


    const navi = useNavigate();

    const { assignedTo } = useUserDetailsQuery({ id: record.userId },
        {
            skip: !record.userId,
            selectFromResult: ({ data, status, isLoading, isFetching }) => ({
                assignedTo: data || '...',
            })
        }
    );


    return (
        <React.Fragment>
            <TableRow sx={index % 2 === 0 ? classes.evenRow : classes.oddRow}>

                <TableCell sx={classes.cell} onClick={() => navi(`/privatedb/details/${record?.id}`)}>
                    <Typography variant="h4">DOT {record.dot}</Typography>
                </TableCell>
                <TableCell sx={classes.cell} onClick={() => navi(`/privatedb/details/${record?.id}`)}>
                    <Typography variant="h4">{record.case_name}</Typography>
                </TableCell>
                <TableCell sx={classes.cell} onClick={() => navi(`/privatedb/details/${record?.id}`)}>
                    <Typography variant="h4">{record.brand}</Typography>
                </TableCell>
                <TableCell sx={classes.cell} onClick={() => navi(`/privatedb/details/${record?.id}`)}>
                    <Typography variant="h4">{record.metric}</Typography>
                </TableCell>

                <TableCell sx={classes.cell} onClick={() => navi(`/privatedb/details/${record?.id}`)}>
                    <Typography variant="h4">{record.section_width}{record.aspect_ratio}R{record.rim_diameter}</Typography>
                </TableCell>

                <TableCell sx={classes.cell} onClick={() => navi(`/privatedb/details/${record?.id}`)}>
                    <Typography variant="h4">{record.speed_rating}</Typography>
                </TableCell>
                <TableCell sx={classes.cell} onClick={() => navi(`/privatedb/details/${record?.id}`)}>
                    <Typography variant="h4">{record.load_range}</Typography>
                </TableCell>
                <TableCell sx={classes.cell} onClick={() => navi(`/privatedb/details/${record?.id}`)}>
                    <Typography variant="h4">{record.construction}</Typography>
                </TableCell>
                <TableCell sx={classes.cell} onClick={() => navi(`/privatedb/details/${record?.id}`)}>
                    <Typography variant="h4">{record.failure_mode}</Typography>
                </TableCell>
                <TableCell sx={classes.cell} onClick={() => navi(`/privatedb/details/${record?.id}`)}>
                    <Typography variant="h4">{record.repairs}</Typography>
                </TableCell>
                <TableCell sx={classes.cell}>
                    <Typography variant="h4" color="secondary">{record.status ? 'ACTIVE' : 'INACTIVE'}</Typography>
                </TableCell>
            </TableRow>
        </React.Fragment>
    );
}

export default PrivateDBRow;